import {Pipe, PipeTransform} from '@angular/core';
import {AssistantSuggestionDto} from '../../Models/Assistant/assistant-suggestion.interface';

@Pipe({
  name: 'assistantSuggestions',
  standalone: false
})
export class AssistantSuggestionsPipe implements PipeTransform {

  transform(items: AssistantSuggestionDto[], suggestionsList: AssistantSuggestionDto[], value: string): AssistantSuggestionDto[] {

    const prompt: string = this.normalizePrompt(value).toLowerCase();

    if (prompt === '') {
      return items;
    }

    // return this.filterSuggestionsByPrompt(suggestionsList, prompt);
    return [];
  }


  /**
   * Limpiar prompt de accentos
   *
   */
  private normalizePrompt(prompt: string): string {
    return prompt?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim() || '';
  }


  /**
   * Obtener sugerencias con mayor coincidencia por las claves
   *
   */
  private filterSuggestionsByPrompt(suggestions: AssistantSuggestionDto[], prompt: string): AssistantSuggestionDto[] {
    const scoredSuggestions = suggestions.map(suggestion => ({
      ...suggestion,
      score: suggestion.keys.reduce((count, key) => count + (prompt.split(/\s+/).some((word) => key.includes(word)) ? 1 : 0), 0)
    }));

    return scoredSuggestions
      .filter((suggestion) => suggestion.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 2)
      .map(({score, ...rest}) => rest);
  }

}
